module.exports = __webpack_public_path__ + "static/media/builtinv2-Pol copy.b35d6a71.png";